module.exports = __webpack_public_path__ + "img/main_point_img01.e13a37f5.svg";